export default "__VITE_ASSET__jbukEFvu__"